import { Button } from '@zorro/design-system/v2/Button';
import { ConnectedIcon } from '@zorro/shared/assets';
import { Icon } from '@zorro/web/design-system';

import { useFinchConnection } from './useFinchConnection';

type Props = {
  employerId: string;
  isFixConnectionMode?: boolean;
};

export const FinchConnect = ({ employerId, isFixConnectionMode }: Props) => {
  const { handleConnect } = useFinchConnection({ employerId });

  if (isFixConnectionMode) {
    return (
      <Button
        onClick={handleConnect}
        variant="secondary"
        size="sm"
        leftSection={<Icon icon={ConnectedIcon} size={20} />}
      >
        Fix connection
      </Button>
    );
  }

  return (
    <Button onClick={handleConnect} size="md">
      Connect
    </Button>
  );
};
